import React from "react";
import "./FooterLinks.css";

const FooterLinks = () => {
    return (
        <footer className="footer-links">
            <div className="links-container">
                <a href="/company">О компании</a>
                <a href="/privacy-policy">Политика конфиденциальности</a>
                <a href="/aml-policy">Полит. AML</a>
                <a href="/terms-of-use">Условия использования</a>
            </div>
        </footer>
    );
};

export default FooterLinks;
